import { makeStyles, Theme } from "@material-ui/core/styles"

export const  useCalendarWrapStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4),
        userSelect: "none",
    },
}))
